var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loader"},[_c('span',{staticClass:"loader__dot pulse pulse__one"}),_c('span',{staticClass:"loader__dot pulse pulse__two"}),_c('span',{staticClass:"loader__dot pulse pulse__three"})])
}]

export { render, staticRenderFns }